import { useState, useEffect } from "react";
import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import ContentHeader from "../../components/ContentHeader";

const Reset = () => {
	// Start with a null state to indicate we don't know the value yet
	const [resetValue, setResetValue] = useState(null);
	const [isSaving, setIsSaving] = useState(false);
	const [isSaved, setIsSaved] = useState(false);
	const default_colors = {
		barBackground: "#5007AA",
		barText: "#FFFFFF",
		button: "#D1C1FF",
		buttonText: "#000000",
	};

	const handleResetInputChange = (event) => {
		setResetValue(event.target.value);
	};

	const handleReset = async (event) => {
		setIsSaved(false); // Reset saved state
		event.preventDefault();
		if ( resetValue != null && resetValue === "reset") {
			if (confirm(__("Do you really want to reset?", "access-control"))) {
				setIsSaving(true);
				try {
					await apiFetch({
						path: "/plac/v1/reset",
						method: "POST",
						data: {
							_wpnonce: window.placAdminData.nonce,
							enable_access_control: true,
							enable_frontend_bar: true,
							enable_shop_manager: false,
							colors: default_colors,
							enable_clean_data_on_uninstall:false
						},
					});

					// Show success checkmark after saving
					setTimeout(() => {
						setIsSaving(false);
						setIsSaved(true);

						// Reset to default state after 2s
						setTimeout(() => {
							setIsSaved(false);
						}, 1000);
					}, 500);
				} catch (error) {
					console.error("Error resetting settings:", error);
					setIsSaving(false);
				}
			}
		} else {
			alert("Invalid input");
		}
	};

	return (
		<>
			
			<div className="settings-container">
				<ContentHeader
					title={"Plugin Reset"}
					description={
						"Want to start over? Go back to the how our plugin was first installed on your site."
					}
				/>

				<div className="content-section">
					<div className="leftSection">
						<h2 className="title header-1 primary-text-color semi-bold">
							{__("Nuclear Site Reset", "access-control")}
						</h2>
						<p className="description header-2 primary-text-color regular">
							{__(
								"Reset evrything to deafult values",
								"access-control",
							)}
						</p>
					</div>

					<div className="rightSection">
						<div className="setting-item">
							<div className="input-container">
								<OverlayTrigger
									placement="top"
									overlay={
										<Tooltip id="shop-manager-tooltip">
											{__(
												"Reset all settings",
												"access-control",
											)}
										</Tooltip>
									}
								>
									<img
										src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
										alt="icon"
										className="icon"
										style={{ cursor: "pointer" }}
									/>
								</OverlayTrigger>

								<div className="input-field">
									<input
										type="text"
										placeholder="Type in: reset"
										className="reset-input"
										value={resetValue}
										onChange={handleResetInputChange}
									/>
								</div>
							</div>
							<div className="global-reset">
								{isSaving ? (
									<div
										className="saving-changes"
										style={{
											paddingLeft: "20px",
											color: "#873eff",
										}}
									>
										<div className="pl-access-control-loading-spinner"></div>
										{__("Changes Saving...", "access-control")}
									</div>
								) : isSaved ? (
									<div
										className="success-checkmark"
										style={{
											paddingLeft: "20px",
											color: "#873eff",
										}}
									>
										<img
											src={`${window.placAdminData.pluginUrl}/assets/images/success-tick-active.svg`}
											alt="quotation-icon"
										/>
										{__("Changes Saved", "access-control")}
									</div>
								) : (
									<a
										href="#"
										onClick={handleReset}
										className="reset-txt-btn header-1 semi-bold purple-text-color"
									>
										{__(
											"Reset WordPress & Delete All Custom Files & Data",
											"access-control",
										)}
									</a>
								)}
							</div>

							<div className="note notice-bg-color">	
								<h6 className="bold">
									{__("Note :", "access-control")}{" "}
									<span className="regular">
										{__(
											"You can access this feature in our premium plugin.",
											"access-control",
										)}
									</span>
								</h6>
							</div>
						</div>
					</div>
				</div>

				<div className="footer-section">
					<button className="save-button disabled purple-bg-40 secondary-text-color" disabled>
						{__("Save Change", "access-control")}
					</button>
					<button className="discard-button disabled purple-text-color btn-border" disabled>
						{__("Reset to Default", "access-control")}
					</button>
				</div>
			</div>
		</>
	);
};

export default Reset;
